import { getApps, initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

function readFirebaseWebConfig() {
  return {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };
}

export function isFirebaseClientConfigured() {
  const c = readFirebaseWebConfig();
  return Boolean(c.apiKey && c.authDomain && c.projectId && c.appId);
}

export function getFirebaseApp() {
  if (!isFirebaseClientConfigured()) {
    throw new Error(
      'Firebase is not configured. Set REACT_APP_FIREBASE_API_KEY, REACT_APP_FIREBASE_AUTH_DOMAIN, ' +
        'REACT_APP_FIREBASE_PROJECT_ID, REACT_APP_FIREBASE_APP_ID (and related keys) in your environment.'
    );
  }
  const config = readFirebaseWebConfig();
  if (!getApps().length) {
    initializeApp(config);
  }
  return getApps()[0];
}

export function getFirebaseAuth() {
  return getAuth(getFirebaseApp());
}

export const googleAuthProvider = new GoogleAuthProvider();
